import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { usePageTitle, useStatoInSolaLettura } from "../../../../layouts/PageHeaderExtra";
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { format } from 'date-fns';
import { conMotivo } from "../../../../components/Util/erroreServer";
import { italianProvinces, sports } from "../../../../components/Util/enum";

export const AdminUserFacilitiesView = () => {

    const { id } = useParams();

	const [loadingShowed, setLoadingShowed] = useState(false);
	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

    const [formData, setFormData] = useState({
        venue_name: '',
        sportType: '',
        playerName: '',
        juniorName: '',
        price: '',
        startDate: '',
        endDate: '',
        status: null,
        originalStatus: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        tipo_cliente: '',
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        is_pagato: false,
        modalita_pagamento: ''
    });

    // Titolo della pagina = nome dell'impianto prenotato, appena caricato.
    usePageTitle(formData?.venue_name);

    // Stato in sola lettura accanto al titolo (da qui non si cambia)
    useStatoInSolaLettura(formData?.status?.label, formData?.originalStatus === 'PAID' ? 'attivo' : formData?.originalStatus === 'UNPAID' ? 'non-attivo' : 'bozza');

    const optionsFatturazione = [
        { value: "privato", label: "Privato" },
        { value: "azienda", label: "Azienda" }
    ]

    const optionsPayment = [
        { value: "CASH", label: "Contanti" },
        { value: "CARD", label: "Carta di credito" },
        { value: "BANK_TRANSFER", label: "Bonifico" }
    ]

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const userBookingVenues = await apiClient.getUserBookingVenueById(token, id);
					setLoadingShowed(false);
                    
                    if(userBookingVenues) {
                        const elementFormData = {
                            venue_name: userBookingVenues.venue_name,
                            sportType: userBookingVenues.sportType,
                            playerName: userBookingVenues.playerName,
                            juniorName: userBookingVenues.juniorName,
                            price: userBookingVenues.price+' €',
                            startDate: userBookingVenues.bookingDate && userBookingVenues.startTime ? 
                                format(new Date(userBookingVenues.bookingDate), 'dd/MM/yyyy') + ' ' + userBookingVenues.startTime : '',
                            endDate: userBookingVenues.bookingDate && userBookingVenues.endTime ? 
                                format(new Date(userBookingVenues.bookingDate), 'dd/MM/yyyy') + ' ' + userBookingVenues.endTime : '',
                        }

                        let status = null;
                        if(userBookingVenues.status === 'PAID') {
                            status = {
                                "label": "Pagato",
                                "class": "text-success"
                            };
                        } else if(userBookingVenues.status === 'UNPAID') {
                            status = {
                                "label": "Non pagato",
                                "class": "text-primary"
                            };
                        } else if(userBookingVenues.status === 'REFUNDED') {
                            status = {
                                "label": "Rimborsato",
                                "class": "text-warning"
                            };
                        } else if(userBookingVenues.status === 'CANCELLED') {
                            status = {
                                "label": "Eliminato",
                                "class": "text-error"
                            };
                        }

                        elementFormData.id = userBookingVenues.id;
                        elementFormData.status = status;
                        elementFormData.originalStatus = userBookingVenues.status;

                        if(userBookingVenues.receiver) {
                            elementFormData.codice_fiscale = userBookingVenues.receiver.tax_code;
                            elementFormData.email = userBookingVenues.receiver.pec;
                            elementFormData.indirizzo = userBookingVenues.receiver.address;
                            elementFormData.cap = userBookingVenues.receiver.zip_code;
                            elementFormData.citta = userBookingVenues.receiver.city;
                            elementFormData.provincia = userBookingVenues.receiver.province;
                            if(userBookingVenues.receiver.type === 'consumer') {
                                elementFormData.tipo_cliente = 'privato';
                                elementFormData.nome = userBookingVenues.receiver.first_name;
                                elementFormData.cognome = userBookingVenues.receiver.last_name;
                            } else if(userBookingVenues.receiver.type === 'business') {
                                elementFormData.tipo_cliente = 'azienda';
                                elementFormData.ragione_sociale = userBookingVenues.receiver.denomination;
                                elementFormData.partita_iva = userBookingVenues.receiver.vat_number;
                                elementFormData.codice_destinatario = userBookingVenues.receiver.sdi_code;
                            }
                        }

                        if(userBookingVenues.status !== 'UNPAID') {
                            elementFormData.is_pagato = true;
                            if(userBookingVenues.payment_method) {
                                elementFormData.modalita_pagamento = userBookingVenues.payment_method;
                            }
                        } else {
                            elementFormData.is_pagato = false;
                        }

                        setFormData(elementFormData);
                    } else {
                        setModalTitle("Errore durante l'operazione");
                        setModalText("Elemento non trovato");
                        setModalShowed(true);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoadingShowed(false);
                setModalTitle("Errore durante l'operazione");
                setModalText(conMotivo("Si è verificato un errore durante il caricamento dei dati"));
                setModalShowed(true);
            }
        };

        fetchData();
    }, [id]);

    const goBack = () => {
        window.history.back();
    };

	return (
		<>
			<Modal className="fade" show={modalShowed} centered>
				<Modal.Header>
					<Modal.Title>{modalTitle}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{modalText}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={() => setModalShowed(false)}>
						Chiudi
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
				</Modal.Body>
			</Modal>

            <Row>
                <div className="col-xl-9">
                    <Card>
                        <Card.Header><h4 className="card-title">Dettaglio prenotazione impianto</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-lg-6">
                                    <Form.Label>Nome impianto</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="venue_name" value={formData.venue_name} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Sport</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="sportType" value={sports.find(s => s.value === formData.sportType)?.label || formData.sportType} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Cliente</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="playerName" value={formData.playerName} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Junior</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="juniorName" value={formData.juniorName} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Data di inizio</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="startDate" value={formData.startDate} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Data di fine</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="endDate" value={formData.endDate} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Prezzo</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="price" value={formData.price} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Fatturazione</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={12}>
                                    <Form.Label>Tipo Cliente</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="tipo_cliente"
                                        value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                        options={optionsFatturazione}
                                    />
                                </Col>
                            </Row>
                            {formData.tipo_cliente === 'azienda' && (
                                <Row className="mt-4">
                                    <Col lg={4}>
                                        <Form.Label>Ragione sociale</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="ragione_sociale"
                                            value={formData.ragione_sociale}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Partita IVA</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="partita_iva"
                                            value={formData.partita_iva}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Codice Destinatario (SDI)</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="codice_destinatario"
                                            value={formData.codice_destinatario}
                                        />
                                    </Col>
                                </Row>
                            )}
                            {formData.tipo_cliente === 'privato' && (
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="nome"
                                            value={formData.nome}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Cognome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="cognome"
                                            value={formData.cognome}
                                        />
                                    </Col>
                                </Row>
                            )}
                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Codice Fiscale</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="codice_fiscale"
                                        value={formData.codice_fiscale}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Email/PEC</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Indirizzo</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="indirizzo"
                                        value={formData.indirizzo}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>CAP</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="cap"
                                        value={formData.cap}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Città</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="citta"
                                        value={formData.citta}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Provincia</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="provincia"
                                        value={italianProvinces.find(option => option.value === formData.provincia)}
                                        options={italianProvinces}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Pagamento</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={6}>
                                    <Form.Label>Pagato</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="is_pagato"
                                        value={optionsBoolean.find(option => option.value === formData.is_pagato)}
                                        options={optionsBoolean}
                                    />
                                </Col>
                                {formData.is_pagato && ( 
                                    <Col md={6}>
                                        <Form.Label>Modalità di pagamento</Form.Label>
                                        <Select
                                            isDisabled
                                            className="mt-2"
                                            name="modalita_pagamento"
                                            value={optionsPayment.find(option => option.value === formData.modalita_pagamento)}
                                            options={optionsPayment}
                                        />
                                    </Col> 
                                )}
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4">
                        <button type="button" className="btn btn-dark light" onClick={() => goBack()}>Indietro</button>
                    </div>
                </div>
                <div className="col-xl-3">
                    <Card>
                        <Card.Body className="text-left">
                            <div>
                                <strong>Visualizzazione dettaglio prenotazione</strong>
                                <br/><br/>
                                Questa è la visualizzazione di sola lettura del dettaglio della prenotazione dell'impianto.
                                <br/><br/>
                                Tutte le informazioni relative alla prenotazione, fatturazione e pagamento sono mostrate in modalità di sola lettura.
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </Row>
		</>
	)

}
export default AdminUserFacilitiesView;